
import _ from 'lodash';

const namespaced = true;

const state = {
  recurrentInterventions: [],
};

const mutations = {
  SET_RECURRENT_INTERVENTIONS(state, recurrentInterventions) {
    state.recurrentInterventions = recurrentInterventions;
  },
};

const actions = {
  async fetchRecurrentInterventionsForMakerAndClient({ dispatch, commit, rootState }, { makerId, clientId } = {}) {
    let recurrentInterventions = [];

    makerId = makerId || rootState[`model/client`].company.id;
    clientId = clientId || rootState[`model/client`].currentAdminClient.id;

    try {
      recurrentInterventions = await dispatch(`model/recurrentIntervention/fetchListForMakerAndClient`, { makerId, clientId }, { root: true });
    } catch (e) {} // eslint-disable-line

    commit(`SET_RECURRENT_INTERVENTIONS`, recurrentInterventions);
  },
};

const getters = {
  recurrentInterventions: state =>
    _.sortBy(state.recurrentInterventions, `id`),
};

export default {
  namespaced, state, mutations, actions, getters,
};
